import React, { lazy } from "react";
import { AUTHORIZATIONS } from "./utils/constants/authorization-constants";

import { SystemConfigurationModulesNames } from "./containers/SystemConfigurationTables/utils";

import {
  AccountingOutputLinks,
  SystemConfigurationLinks,
  ComplianceDocumentsLinks,
  ConfigureCompanyAccountLinks,
  MyDataLinks,
  MyTeamPresenceAndLeavesLinks,
  MyTeamProjectAssignmentLinks,
  MyTeamTravelAndExpensesLinks,
  MyTravelAndExpensesLinks,
  PayrollOutputLinks,
  PoliciesLinks,
  PoliciesManagmentLinks,
  ProccessDocumentsLinks,
  ProcessAccountingLinks,
  ProcessEmploymentAndPayrollLinks,
  QuestionsAndRequestsLinks,
  RecruitingLinks,
  SendUsLinks,
  UserManagementLinks,
  MyDocumentsLinks,
  MyTeamPayrollOutput,
  MyClientTeamPresenceAndLeavesLinks,
  MyClientTeamPendingApprovalsLinks,
  MyTeamPendingApprovalsLinks,
  MyTeamDocumentsLinks,
  SystemAnalyticsLinks,
  AccountManagementLinks,
  MyTeamPoliciesLinks,
  ClockingLocationQRCodeLinks,
  DocumentTemplatesLinks,
} from "./widgetLink";
import MyDocuments from "./views/my-data-and-documents/MyDocuments";
import EmployeeDocuments from "./views/employee-data-and-documents/EmployeeDocuments";
import EmployeeData from "./views/employee-data-and-documents/EmployeeData";
import PendingClientApprovals from "./containers/MyTeamProjectAssignments/ProjectAssignmentsPendingApprovals/PendingClientApprovals";
import ManagerExpenseReportApprovalsByLink from "./views/notifications-by-email/manager-expense-reports-approvals-by-link/ManagerExpenseReportsApprovalsByLink";
import ClientExpenseReportsApprovalsByLink from "./views/notifications-by-email/client-expense-reports-approvals-by-links/ClientExpenseReportsApprovalsByLink";
import EmployeeCostReportPage from "./views/employee-cost-report/EmployeeCostReportPage";
import SplitEmployeeDocumentTable from "./containers/SplitEmployeeDocument/SplitEmployeeDocumentTable";
import EmployeeCostSectionTypeTable from "./containers/SystemConfigurationTables/EmployeeCostSectionType/EmployeeCostSectionTypeTable";
import ProvidePayrollInput from "./views/provide-payroll-input/ProvidePayrollInput";
// import ReportAlertLine from "./views/AlertLine/ReportAlertLine/ReportAlertLine";
import AlertLineURLs from "./views/system-settings/AlertLineURLs/AlertLineURLs";
import ViolationClassification from "./views/system-settings/ViolationClassification/ViolationClassification";
import AlertLineReportStatus from "./views/system-settings/AlertLinReportStatus/AlertLineReportStatus";
import AlertLinePage from "./views/alert-line-report/AlertLinePage/AlertLinePage";
import ManageMail from "./views/manage-mail/ManageMail";
import MySurveysPage from "./views/my-surveys/MySurveysPage";
import TnALocationCodesPage from "./views/tna-location-codes/TnALocationCodesPage";

const DataPrivacyPage = lazy(() => import("./views/data-privacy/DataPrivacyPage"));
const SignOffByLink = lazy(() => import("./views/notifications-by-email/sign-off-by-link/SignOffByLink"));
const AbsencesApproveRejectByLinks = lazy(
  () => import("./views/notifications-by-email/absences-approve-reject-by-links/AbsencesApproveRejectByLinks")
);
const ExtrahoursApproveRejectByLinks = lazy(
  () => import("./views/notifications-by-email/extrahours-approve-reject-by-links/ExtrahoursApproveRejectByLinks")
);
const ClientApproveRejectAbsencesByLinks = lazy(
  () =>
    import("./views/notifications-by-email/client-approve-reject-absences-by-links/ClientApproveRejectAbsencesByLinks")
);
const ClientApproveRejectExtrahoursByLinks = lazy(
  () =>
    import(
      "./views/notifications-by-email/client-extrahours-approve-reject-by-links/ClientApproveRejectExtrahoursByLinks"
    )
);
const AbsencesCancellationApproveRejectByLinks = lazy(
  () =>
    import(
      "./views/notifications-by-email/absences-cancellation-approve-reject-by-links/AbsencesCancellationApproveRejectByLinks"
    )
);
const Login = lazy(() => import("./views/login-like-pages/login/Login"));
const Register = lazy(() => import("./views/login-like-pages/register/Register"));
const ForgotPassword = lazy(() => import("./views/login-like-pages/forgot-password/ForgotPassword"));
const ResetPassword = lazy(() => import("./views/login-like-pages/reset-password/ResetPassword"));
const ConfirmEmail = lazy(() => import("./views/login-like-pages/confirm-email/ConfirmEmail"));
const Page404 = lazy(() => import("./views/page-404/Page404"));
const Page500 = lazy(() => import("./views/page-500/Page500"));
const ThemeEditor = lazy(() => import("./views/theme-editor/ThemeEditor"));
const Dashboard = lazy(() => import("./views/dashboard/Dashboard"));
const UserProfile = lazy(() => import("./views/user-profile/UserProfile"));
const CompanyAccountProfile = lazy(() => import("./views/company-account-profile/CompanyAccountProfile"));
const CompanyAccountConfiguration = lazy(() => import("./views/company-account-profile/CompanyAccountConfiguration"));
const CompanyLegalEntities = lazy(() => import("./views/legal-entities/CompanyLegalEntities/CompanyLegalEntities"));
const AccountingMasterData = lazy(() => import("./views/legal-entities/AccountingMasterData/AccountingMasterData"));
const ClientProfilePage = lazy(
  () => import("./views/legal-entities/ClientVendorProfilePage/ClientProfilePage/ClientProfilePage")
);
const VendorProfilePage = lazy(
  () => import("./views/legal-entities/ClientVendorProfilePage/VendorProfilePage/VendorProfilePage")
);
const ProjectAssignmentsPendingApprovals = lazy(
  () =>
    import(
      "./containers/MyTeamProjectAssignments/ProjectAssignmentsPendingApprovals/ProjectAssignmentsPendingApprovals"
    )
);
const ProviderAccounts = lazy(() => import("./views/system-settings/Providers/ProviderAccounts/ProviderAccounts"));
const CompanyAccounts = lazy(() => import("./views/system-settings/CompanyAccounts/CompanyAccounts"));
const SystemSettings = lazy(() => import("./views/system-settings/SystemSettings"));
const ProviderSettings = lazy(() => import("./views/provider-settings/ProviderSettings"));
const UsersTables = lazy(() => import("./views/system-settings/UsersTables/UsersTables"));
const TransactionsForecasts = lazy(() => import("./views/process-accounting/Transactions/TransactionsForecasts"));
const BankAndCashOverview = lazy(() => import("./views/process-accounting/BankAndCashOverview/BankAndCashOverview"));
const MyLeavesTable = lazy(() => import("./views/MyLeaves/MyLeavesTable"));
const LegalEntityDataPage = lazy(() => import("./views/legal-entities/LegalEntityDataPage/LegalEntityDataPage"));
const CompanyAccountDataPage = lazy(
  () => import("./views/company-account-folder/CompanyAccountDataPage/CompanyAccountDataPage")
);
const TnACalendarsTable = lazy(
  () => import("./containers/SystemConfigurationTables/TnAConfig/TnACalendarsTable/TnACalendarsTable")
);
const DocumentTemplatesTable = lazy(
  () => import("./containers/SystemConfigurationTables/DocumentTemplates/DocumentTemplatesTable")
);
const LegalEntityAssets = lazy(
  () => import("./views/process-accounting/LegalEntityAssetsTable/LegalEntityAssetsTable")
);
const LegalEntityLoans = lazy(() => import("./views/process-accounting/LegalEntityLoansTable/LegalEntityLoansTable"));

const ClientVendorInvoicesWrapper = lazy(
  () => import("./views/process-accounting/LegalEntitiesInvoicesBalance/ClientVendorInvoicesWrapper")
);
const EmployeesView = lazy(() => import("./views/legal-entities/EmployeesView/EmployeesView"));
const EmployeeReport = lazy(() => import("./views/EmployeeReport/EmployeeReport"));
const EmployeeGroups = lazy(() => import("./views/legal-entities/EmployeeGroupsPage/EmployeeGroupsPage"));
const EmployeesMutations = lazy(() => import("./views/legal-entities/EmployeesMutations/EmployeesMutations"));
const Clarifications = lazy(() => import("./views/clarifications/Clarifications"));
const Documents = lazy(() => import("./views/documents/Documents"));
const ComplianceDocuments = lazy(() => import("./views/documents-reports/ComplianceDocuments/ComplianceDocuments"));

const Recruiting = lazy(() => import("./views/recruiting/Recruiting"));

const AccountingOutputDocuments = lazy(
  () => import("./views/documents-reports/AccountingDocuments/AccountingOutputDocuments")
);

const CompanyAccountDocuments = lazy(() => import("./views/company-account-documents/CompanyAccountDocuments"));

const CompanyAccountOverviewWrapper = lazy(
  () => import("./views/company-account-overview/CompanyAccountOverviewWrapper")
);

const LegalEntityAdministrativeProcessWrapper = lazy(
  () => import("./views/legal-entity-administrative-process/LegalEntityAdministrativeProcessWrapper")
);

const ArchiveDownloadWrapper = lazy(() => import("./views/archive-download/ArchiveDownloadWrapper"));

const AccountingCalendar = lazy(() => import("./views/legal-entities/AccountingCalendar/AccountingCalendar"));

const PayrollOutputDocuments = lazy(() => import("./views/documents-reports/PayrollDocuments/PayrollOutputDocuments"));
const MyTeamPayrollOutputReport = lazy(
  () => import("./views/documents-reports/MyTeamPayrollOutputReport/MyTeamPayrollOutputReport")
);
const InvoiceTrackingReport = lazy(
  () => import("./views/documents-reports/InvoiceTrackingReport/InvoiceTrackingReport")
);
// const EmployeeDataAndDocuments = lazy(() => import("./views/employee-data-and-documents/EmployeeDataAndDocuments"));
// const MyDataAndDocuments = lazy(() => import("./views/my-data-and-documents/MyDataAndDocuments"));
const MyData = lazy(() => import("./views/my-data-and-documents/MyData"));

const TnALegislationConfig = lazy(() => import("./containers/TnAConfig/TnaLegislationConfig"));
const TnACompanyAccountConfig = lazy(() => import("./containers/TnAConfig/TnACompanyAccountConfig"));
const TnALegalEntityConfig = lazy(() => import("./containers/TnAConfig/TnALegalEntityConfig"));
const TnAEmployeeConfig = lazy(() => import("./containers/TnAConfig/TnAEmployeeConfig"));
const EmployeeDataPage = lazy(() => import("./views/legal-entities/EmployeeDataPage/EmployeeDataPage"));
const TnAEmployeeGroupConfig = lazy(() => import("./containers/TnAConfig/TnAEmployeeGroupConfig"));
const MyTAndA = lazy(() => import("./views/my-t-and-a/MyTAndA"));
const MyEeTAndA = lazy(() => import("./views/my-t-and-a/MyEeTAndA"));
const TnAOverviews = lazy(() => import("./containers/MyTeamPresenceAndLeaves/MyTeamPresenceAndLeaves"));

const MyTeamProjectAssignments = lazy(() => import("./containers/MyTeamProjectAssignments/MyTeamProjectAssignments"));
const ManageEmployeeSurveyConfigurationPage = lazy(
  () => import("./views/employee-survery-configuration/ManageEmployeeSurveyConfigurationPage")
);
const ManageProviderSiteAdvertisementPopupsPage = lazy(
  () => import("./views/provider-site-advertisement-popups/ManageProviderSiteAdvertisementPopupsPage")
);
//#region SystemConfiguration Tables
// Import map for SystemConfigurationTables components
const systemConfigImportMap = {
  EmployeeSurveyExplanationSuggestions: () =>
    import(
      "./containers/SystemConfigurationTables/EmployeeSurveyExplanationSuggestions/EmployeeSurveyExplanationSuggestionsTable"
    ),
  EmployeeSurveyItemTypes: () =>
    import(
      "./containers/SystemConfigurationTables/EmployeeSurveyConfigurationItemTypes/EmployeeSurveyConfigurationItemTypes"
    ),
  MailInboxTable: () => import("./containers/SystemConfigurationTables/MailInboxTable/MailInboxTable"),
  LegislationEmployeeCostConfigurationTypeTable: () =>
    import("./containers/SystemConfigurationTables/EmployeeCostSectionType/EmployeeCostSectionTypeTable"),
  AlertLineSuggestedNotesTable: () =>
    import("./containers/SystemConfigurationTables/AlertLineSuggestedNotes/AlertLineSuggestedNotesTable"),
  TnAConfig: () => import("./containers/SystemConfigurationTables/TnAConfig/TnAConfig"),
  AddEditTnASchedule: () =>
    import("./containers/SystemConfigurationTables/TnAConfig/TnASchedulesTable/TnAScheduleConfig/TnAScheduleConfig"),
  AssetTypes: () => import("./containers/SystemConfigurationTables/AssetTypes/AssetTypesTable"),
  AuditTypesAndReports: () => import("./containers/SystemConfigurationTables/AuditTypes/AuditTypesAndReports"),
  AvailableLanguages: () => import("./containers/SystemConfigurationTables/AvailableLanguages/AvailableLanguagesTable"),
  ClarificationStatuses: () =>
    import("./containers/SystemConfigurationTables/ClarificationStatuses/ClarificationStatusesTable"),
  ClarificationTypes: () => import("./containers/SystemConfigurationTables/ClarificationTypes/ClarificationTypesTable"),
  CompanyAccountTypes: () =>
    import("./containers/SystemConfigurationTables/CompanyAccountTypes/CompanyAccountTypesTable"),
  Countries: () => import("./containers/SystemConfigurationTables/Countries/CountriesTable"),
  TravelExpenseSuggestedAuditComment: () =>
    import(
      "./containers/SystemConfigurationTables/TravelExpenseSuggestedAuditComment/TravelExpenseSuggestedAuditCommentTable"
    ),
  Currencies: () => import("./containers/SystemConfigurationTables/Currencies/CurrenciesTable"),
  ArchiveStructures: () => import("./containers/SystemConfigurationTables/ArchiveStructures/ArchiveStructures"),
  DocumentCategories: () => import("./containers/SystemConfigurationTables/DocumentCategories/DocumentCategoriesTable"),
  DocumentTypes: () => import("./containers/SystemConfigurationTables/DocumentTypes/DocumentTypes"),
  DocumentRequestTypes: () =>
    import("./containers/SystemConfigurationTables/DocumentRequestTypes/DocumentRequestTypesTable"),
  DynamicFieldDefinitions: () =>
    import("./containers/SystemConfigurationTables/DynamicFieldDefinitions/DynamicFieldDefinitionsTable"),
  ExchangeRatesAndSources: () => import("./containers/SystemConfigurationTables/ExchangeRates/ExchangeRatesAndSources"),
  EmailTemplates: () => import("./containers/SystemConfigurationTables/EmailTemplates/EmailTemplatesTable"),
  NotificationSourceTypes: () =>
    import("./containers/SystemConfigurationTables/NotificationSourceTypes/NotificationSourceTypesTable"),
  DigestFrequencies: () => import("./containers/SystemConfigurationTables/DigestFrequencies/DigestFrequenciesTable"),
  EmployeeDependentTypes: () =>
    import("./containers/SystemConfigurationTables/EmployeeDependentTypes/EmployeeDependentTypesTable"),
  EventTypes: () => import("./containers/SystemConfigurationTables/EventTypes/EventTypesTable"),
  FieldValueTypes: () => import("./containers/SystemConfigurationTables/FieldValueTypes/FieldValueTypesTable"),
  FileStorageLocations: () =>
    import("./containers/SystemConfigurationTables/FileStorageLocations/FileStorageLocationsTable"),
  Legislations: () => import("./containers/SystemConfigurationTables/Legislations/Legislations"),
  PaymentTypes: () => import("./containers/SystemConfigurationTables/PaymentTypes/PaymentTypesTable"),
  Skills: () => import("./containers/SystemConfigurationTables/Skills/SkillsTable"),
  AdministrativeProcessTypesTable: () =>
    import("./containers/SystemConfigurationTables/AdministrativeProcessTypes/AdministrativeProcessTypesTable"),
  ExpensesRevenueTypes: () =>
    import("./containers/SystemConfigurationTables/ExpensesRevenueTypes/ExpensesRevenueTypesTable"),
  PnLTypes: () => import("./containers/SystemConfigurationTables/PnLTypes/PnLTypesTable"),
  PnLCalculationPage: () => import("./containers/SystemConfigurationTables/PnLCalculation/PnLCalculationPage"),
  PnLConfig: () => import("./containers/SystemConfigurationTables/PnLConfig/PnLConfig"),
  TransactionStatuses: () =>
    import("./containers/SystemConfigurationTables/TransactionStatuses/TransactionStatusesTable"),
  TransactionTypes: () => import("./containers/SystemConfigurationTables/TransactionTypes/TransactionTypesTable"),
  WidgetsConfig: () => import("./containers/SystemConfigurationTables/Widgets/WidgetsConfig"),
  TravelExpenseTypes: () => import("./containers/SystemConfigurationTables/TravelExpenseTypes/TravelExpenseTypesTable"),
  LocationTypes: () => import("./containers/SystemConfigurationTables/LocationTypes/LocationTypesTable"),
  GTNSourceTypes: () => import("./containers/SystemConfigurationTables/GTNSourceTypes/GTNSourceTypesTable"),
  AccountingEntryStatuses: () =>
    import("./containers/SystemConfigurationTables/AccountingEntryStatuses/AccountingEntryStatusesTable"),
  AccountingEntryTypes: () =>
    import("./containers/SystemConfigurationTables/AccountingEntryTypes/AccountingEntryTypesTable"),
  PayrollEntryStatuses: () =>
    import("./containers/SystemConfigurationTables/PayrollEntryStatuses/PayrollEntryStatusesTable"),
  PayrollEntryTypes: () => import("./containers/SystemConfigurationTables/PayrollEntryTypes/PayrollEntryTypesTable"),
  WageTypes: () => import("./containers/SystemConfigurationTables/WageTypes/WageTypes"),
  TravelExpenseSuggestedNotes: () =>
    import("./containers/SystemConfigurationTables/TravelExpenseSuggestedNotes/TravelExpenseSuggestedNotesTable"),
};

const EmployeeSurveyExplanationSuggestions = lazy(systemConfigImportMap.EmployeeSurveyExplanationSuggestions);
const EmployeeSurveyItemTypes = lazy(systemConfigImportMap.EmployeeSurveyItemTypes);
const MailInboxTable = lazy(systemConfigImportMap.MailInboxTable);
const LegislationEmployeeCostConfigurationTypeTable = lazy(
  systemConfigImportMap.LegislationEmployeeCostConfigurationTypeTable
);
const AlertLineSugestedNotesTable = lazy(systemConfigImportMap.AlertLineSuggestedNotesTable);
const TnAConfig = lazy(systemConfigImportMap.TnAConfig);
const AddEditTnASchedule = lazy(systemConfigImportMap.AddEditTnASchedule);
const AssetTypes = lazy(systemConfigImportMap.AssetTypes);
const AuditTypesAndReports = lazy(systemConfigImportMap.AuditTypesAndReports);
const AvailableLanguages = lazy(systemConfigImportMap.AvailableLanguages);
const ClarificationStatuses = lazy(systemConfigImportMap.ClarificationStatuses);
const ClarificationTypes = lazy(systemConfigImportMap.ClarificationTypes);
const CompanyAccountTypes = lazy(systemConfigImportMap.CompanyAccountTypes);
const Countries = lazy(systemConfigImportMap.Countries);
const TravelExpenseSuggestedAuditComment = lazy(systemConfigImportMap.TravelExpenseSuggestedAuditComment);
const Currencies = lazy(systemConfigImportMap.Currencies);
const ArchiveStructures = lazy(systemConfigImportMap.ArchiveStructures);
const DocumentCategories = lazy(systemConfigImportMap.DocumentCategories);
const DocumentTypes = lazy(systemConfigImportMap.DocumentTypes);
const DocumentRequestTypes = lazy(systemConfigImportMap.DocumentRequestTypes);
const DynamicFieldDefinitions = lazy(systemConfigImportMap.DynamicFieldDefinitions);
const ExchangeRatesAndSources = lazy(systemConfigImportMap.ExchangeRatesAndSources);
const EmailTemplates = lazy(systemConfigImportMap.EmailTemplates);
const NotificationSourceTypes = lazy(systemConfigImportMap.NotificationSourceTypes);
const DigestFrequencies = lazy(systemConfigImportMap.DigestFrequencies);
const EmployeeDependentTypes = lazy(systemConfigImportMap.EmployeeDependentTypes);
const EventTypes = lazy(systemConfigImportMap.EventTypes);
const FieldValueTypes = lazy(systemConfigImportMap.FieldValueTypes);
const FileStorageLocations = lazy(systemConfigImportMap.FileStorageLocations);
const Legislations = lazy(systemConfigImportMap.Legislations);
const PaymentTypes = lazy(systemConfigImportMap.PaymentTypes);
const Skills = lazy(systemConfigImportMap.Skills);
const AdministrativeProcessTypesTable = lazy(systemConfigImportMap.AdministrativeProcessTypesTable);
const ExpensesRevenueTypes = lazy(systemConfigImportMap.ExpensesRevenueTypes);
const PnLTypes = lazy(systemConfigImportMap.PnLTypes);
const PnLCalculationPage = lazy(systemConfigImportMap.PnLCalculationPage);
const PnLConfig = lazy(systemConfigImportMap.PnLConfig);
const TransactionStatuses = lazy(systemConfigImportMap.TransactionStatuses);
const TransactionTypes = lazy(systemConfigImportMap.TransactionTypes);
const WidgetsConfig = lazy(systemConfigImportMap.WidgetsConfig);

const TravelExpenseTypes = lazy(systemConfigImportMap.TravelExpenseTypes);
const LocationTypes = lazy(systemConfigImportMap.LocationTypes);

const GTNSourceTypes = lazy(systemConfigImportMap.GTNSourceTypes);

const UserAccessRightsView = lazy(() => import(`./views/user-access-rights/UserAccessRightsView`));
const UserActivity = lazy(() => import(`./views/user-activity/UserActivity`));
const AccessToCompanyAccounts = lazy(() => import(`./views/access-to-company-accounts/AccessToCompanyAccounts`));
const AccessToLegalEntities = lazy(() => import("./views/access-to-legal-entities/AccessToLegalEntities"));

const AccountingInputs = lazy(() => import("./views/legal-entities/AccountinglInputs/AccountingInputsPage"));

const AccountingEntryStatuses = lazy(systemConfigImportMap.AccountingEntryStatuses);

const AccountingEntryTypes = lazy(systemConfigImportMap.AccountingEntryTypes);

const PayrollEntryStatuses = lazy(systemConfigImportMap.PayrollEntryStatuses);

const PayrollEntryTypes = lazy(systemConfigImportMap.PayrollEntryTypes);

const WageTypes = lazy(systemConfigImportMap.WageTypes);

const TravelExpenseSuggestedNotes = lazy(systemConfigImportMap.TravelExpenseSuggestedNotes);

const PayrollInputs = lazy(() => import("./views/legal-entities/PayrollInputs/PayrollInputsPage"));

const PayrollRuns = lazy(() => import("./views/legal-entities/PayrollRuns/PayrollRunsPage"));

const ViewPolicies = lazy(() => import("./views/policies/view-policies/ViewPolicies"));

const ManagePolicies = lazy(() => import("./views/policies/manage-policies/ManagePolicies"));

const SharedDocument = lazy(() => import("./views/shared-document/SharedDocument"));

const PnLReports = lazy(() => import("./containers/PnLReports/PnLReports"));

const ManageTravelAndExpenses = lazy(
  () => import("./views/travel-and-expenses/ManageTravelAndExpenses/ManageTravelAndExpenses")
);

const MyTravelAndExpenses = lazy(() => import("./views/travel-and-expenses/MyTravelAndExpenses/MyTravelAndExpenses"));

const IncomingDocumentsPage = lazy(
  () => import("./containers/IncomingDocuments/IncomingDocumentsPage/IncomingDocumentsPage")
);

const MyClientTeamPresenceAndLeaves = lazy(
  () => import("./containers/MyClientTeamPresenceAndLeaves/MyClientTeamPresenceAndLeaves")
);

const MyTeamDocuments = lazy(() => import("./views/my-team-documents/MyTeamDocuments"));
const ConsolidationGroupsTable = lazy(() => import("./views/consolidation-groups/ConsolidationGroupsTable"));

const ManageAlertLine = lazy(() => import("./views/alert-line-report/ManageAlertLine/ManageAlertLine"));

const UserLoginStats = lazy(() => import("./containers/UserLoginStats/UserLoginStats"));
const LegalEntityClientsFilteredByEmployeeGroupsTable = lazy(
  () =>
    import("./containers/LegalEntityClientsFilteredByEmployeeGroupTable/LegalEntityClientsFilteredByEmployeeGroupTable")
);

const MyTeamPolicies = lazy(() => import("./views/my-team-policies/MyTeamPolicies"));
const TnAClockingLocationQRCodePage = lazy(
  () => import("./views/tna-clocking-location-qr-code/TnAClockingLocationQRCodePage")
);

interface CommonRoute {
  name: string;
  path: string;
  exact?: boolean;
  element: JSX.Element;
}

export const publicRoutes: CommonRoute[] = [
  {
    path: "data-privacy",
    name: "Data privacy",
    element: <DataPrivacyPage />,
  },
  {
    path: "tna-timesheet-signoff",
    name: "Sign off",
    element: <SignOffByLink />,
  },
  {
    path: "tna-absences-approve",
    name: "Approve absences",
    element: <AbsencesApproveRejectByLinks approveReject={"approve"} />,
  },
  {
    path: "tna-absences-reject",
    name: "Reject absences",
    element: <AbsencesApproveRejectByLinks approveReject={"reject"} />,
  },
  {
    path: "er-approve",
    name: "Approve expense report",
    element: <ManagerExpenseReportApprovalsByLink approveReject={"approve"} />,
  },
  {
    path: "er-reject",
    name: "Reject expense report",
    element: <ManagerExpenseReportApprovalsByLink approveReject={"reject"} />,
  },
  {
    path: "er-client-approve",
    name: "Approve expense report",
    element: <ClientExpenseReportsApprovalsByLink approveReject={"approve"} />,
  },
  {
    path: "er-client-reject",
    name: "Reject expense report",
    element: <ClientExpenseReportsApprovalsByLink approveReject={"reject"} />,
  },
  {
    path: "tna-eh-approve",
    name: "Approve extrahours",
    element: <ExtrahoursApproveRejectByLinks approveReject={"approve"} />,
  },
  {
    path: "tna-eh-reject",
    name: "Reject extrahours",
    element: <ExtrahoursApproveRejectByLinks approveReject={"reject"} />,
  },
  {
    path: "tna-absences-client-approve",
    name: "Client approve absences",
    element: <ClientApproveRejectAbsencesByLinks approveReject={"approve"} />,
  },
  {
    path: "tna-absences-client-reject",
    name: "Client reject absences",
    element: <ClientApproveRejectAbsencesByLinks approveReject={"reject"} />,
  },
  {
    path: "tna-eh-client-approve",
    name: "Client approve extrahours",
    element: <ClientApproveRejectExtrahoursByLinks approveReject={"approve"} />,
  },
  {
    path: "tna-eh-client-reject",
    name: "Client reject extrahours",
    element: <ClientApproveRejectExtrahoursByLinks approveReject={"reject"} />,
  },
  {
    path: "tna-absence-cancellation-approve",
    name: "Approve absences cancellation",
    element: <AbsencesCancellationApproveRejectByLinks approveReject={"approve"} />,
  },
  {
    path: "tna-absence-cancellation-reject",
    name: "Reject absences cancellation",
    element: <AbsencesCancellationApproveRejectByLinks approveReject={"reject"} />,
  },
  {
    path: "login",
    name: "Login",
    element: <Login />,
  },
  {
    path: "register",
    name: "Register",
    element: <Register />,
  },
  {
    path: "forgot-password",
    name: "Forgot password",
    element: <ForgotPassword />,
  },
  {
    path: "reset-password",
    name: "Reset password",
    element: <ResetPassword />,
  },
  {
    path: "confirm-email",
    name: "Confirm email address",
    element: <ConfirmEmail />,
  },
  {
    path: "404",
    name: "404",
    element: <Page404 />,
  },
  {
    path: "500",
    name: "500",
    element: <Page500 />,
  },
  {
    path: "terms-of-service",
    name: "Terms of service",
    element: <Page500 />,
  },
  {
    path: "privacy-policy",
    name: "Privacy policy",
    element: <Page500 />,
  },
  {
    path: "shared-document/:id",
    name: "shared-document",
    element: <SharedDocument />,
  },
  {
    path: "alert-line/:url",
    name: "alert-line",
    element: <AlertLinePage />,
  },
];

export const privateRoutes = [
  {
    path: "/",
    name: "Home",
    element: <Dashboard />,
    accessDomains: "", // just to let the app redirect on dashboard
    fieldAccess: "",
  },
  {
    path: "theme-editor",
    name: "Theme",
    element: <ThemeEditor />,
    accessDomains: AUTHORIZATIONS.CompanyAccountsAccess.CompanyAccountConfig,
  },
  // Provider settings
  {
    path: "provider-settings",
    name: "Provider Settings",
    element: <ProviderSettings />,
    accessDomains: AUTHORIZATIONS.ServiceProvidersAccess.ManageUserAccessToServiceProvider,
  },
  // System settings
  {
    path: "system-settings",
    name: "System Settings",
    element: <SystemSettings />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  // System settings - accounts
  {
    path: "system-settings/accounts/provider-accounts",
    name: "Provider Accounts",
    element: <ProviderAccounts />,
    accessDomains: AUTHORIZATIONS.SystemAccess.ServiceProvidersConfig,
  },
  {
    path: "system-settings/accounts/company-accounts",
    name: "Company Accounts",
    element: <CompanyAccounts />,
    accessDomains: AUTHORIZATIONS.SystemAccess.CompanyAccountsConfig,
  },
  {
    path: "system-settings/accounts/company-accounts/tna-config/:id",
    name: "Company Accounts TnAConfig",
    element: <TnACompanyAccountConfig />,
    accessDomains: AUTHORIZATIONS.SystemAccess.CompanyAccountsConfig,
  },
  {
    path: "system-settings/accounts/users",
    name: "Users",
    element: <UsersTables />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/accounts/user-access-rights",
    name: "User Access Rights",
    element: <SystemSettings />,
    accessDomains: [
      AUTHORIZATIONS.SystemAccess.ManageUserAdminAccess,
      AUTHORIZATIONS.SystemAccess.SystemConfig,
      AUTHORIZATIONS.SystemAccess.ServiceProvidersConfig,
      AUTHORIZATIONS.SystemAccess.CompanyAccountsConfig,
      AUTHORIZATIONS.CompanyAccountsAccess.ManageUserAdminAccessToCompanyAccounts,
      AUTHORIZATIONS.CompanyAccountsAccess.CompanyAccountConfig,
      AUTHORIZATIONS.LegalEntityAccess.ManageUserAdminAccess_ToLegalEntities,
      AUTHORIZATIONS.CompanyAccountsAccess.LegalEntityAdminAccess,
      AUTHORIZATIONS.LegalEntityAccess.LegalEntityConfig,
      AUTHORIZATIONS.CompanyAccountsAccess.EmployeeGroupConfig,
      AUTHORIZATIONS.EmployeesAccess.GiveUsersAccessToThisEmployeeGroup,
      AUTHORIZATIONS.RecruitingAccess.CanProvideUserAccess,
    ],
  },
  // System settings - system configuration
  {
    path: "system-settings/system-configuration/accounting-entry-statuses",
    name: SystemConfigurationModulesNames.AccountingEntryStatuses,
    element: <AccountingEntryStatuses />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/accounting-entry-types",
    name: SystemConfigurationModulesNames.AccountingEntryTypes,
    element: <AccountingEntryTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/tn-a-config",
    name: SystemConfigurationModulesNames.TnAConfig,
    element: <TnAConfig />,
    accessDomains: [
      AUTHORIZATIONS.SystemAccess.SystemConfig,
      AUTHORIZATIONS.SystemAccess.MaintainTnASchedules,
      AUTHORIZATIONS.SystemAccess.MaintainTnACalendars,
    ],
  },
  {
    path: "system-settings/system-configuration/tn-a-config/tna-schedule/:id",
    name: SystemConfigurationModulesNames.TnAConfig,
    element: <AddEditTnASchedule />,
    accessDomains: [AUTHORIZATIONS.SystemAccess.SystemConfig, AUTHORIZATIONS.SystemAccess.MaintainTnASchedules],
  },
  {
    path: "system-settings/system-configuration/asset-types",
    name: SystemConfigurationModulesNames.AssetTypes,
    element: <AssetTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/audit-types",
    name: SystemConfigurationModulesNames.AuditTypes,
    element: <AuditTypesAndReports />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/available-languages",
    name: SystemConfigurationModulesNames.AvailableLanguages,
    element: <AvailableLanguages />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/exchange-rates",
    name: SystemConfigurationModulesNames.ExchangeRatesAndSrouces,
    element: <ExchangeRatesAndSources />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/email-templates",
    name: SystemConfigurationModulesNames.EmailTemplates,
    element: <EmailTemplates />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/notification-source-types",
    name: SystemConfigurationModulesNames.NotificationSourceTypes,
    element: <NotificationSourceTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/digest-frequencies",
    name: SystemConfigurationModulesNames.DigestFrequencies,
    element: <DigestFrequencies />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/corp-event-types",
    name: SystemConfigurationModulesNames.EventTypes,
    element: <EventTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/clarification-statuses",
    name: SystemConfigurationModulesNames.ClarificationStatuses,
    element: <ClarificationStatuses />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/clarification-types",
    name: SystemConfigurationModulesNames.ClarificationTypes,
    element: <ClarificationTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/company-account-types",
    name: SystemConfigurationModulesNames.CompanyAccountTypes,
    element: <CompanyAccountTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/countries",
    name: SystemConfigurationModulesNames.Countries,
    element: <Countries />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/travel-expense-suggested-audit-comment",
    name: SystemConfigurationModulesNames.TravelExpenseSuggestedAuditComment,
    element: <TravelExpenseSuggestedAuditComment />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/skills",
    name: SystemConfigurationModulesNames.Skills,
    element: <Skills />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/administrative-process-types",
    name: SystemConfigurationModulesNames.AdministrativeProcessTypes,
    element: <AdministrativeProcessTypesTable />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/expenses-revenue-types",
    name: SystemConfigurationModulesNames.ExpensesRevenueTypes,
    element: <ExpensesRevenueTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/pn-l-types",
    name: SystemConfigurationModulesNames.PnLTypes,
    element: <PnLTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/pn-l-calculation",
    name: SystemConfigurationModulesNames.PnLCalculation,
    element: <PnLCalculationPage />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/pn-l-config",
    name: SystemConfigurationModulesNames.PnLConfig,
    element: <PnLConfig />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/currencies",
    name: SystemConfigurationModulesNames.Currencies,
    element: <Currencies />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/archive-structures",
    name: SystemConfigurationModulesNames.ArchiveStructures,
    element: <ArchiveStructures />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/document-categories",
    name: SystemConfigurationModulesNames.DocumentCategories,
    element: <DocumentCategories />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/document-types",
    name: SystemConfigurationModulesNames.DocumentTypes,
    element: <DocumentTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/document-request-types",
    name: SystemConfigurationModulesNames.DocumentRequestTypes,
    element: <DocumentRequestTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/dynamic-field-definitions",
    name: SystemConfigurationModulesNames.DynamicFieldDefinitions,
    element: <DynamicFieldDefinitions />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/employee-dependent-types",
    name: SystemConfigurationModulesNames.EmployeeDependentTypes,
    element: <EmployeeDependentTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/field-value-types",
    name: SystemConfigurationModulesNames.FieldValueTypes,
    element: <FieldValueTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/file-storage-locations",
    name: SystemConfigurationModulesNames.FileStorageLocations,
    element: <FileStorageLocations />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/legislations",
    name: SystemConfigurationModulesNames.Legislations,
    element: <Legislations />,
    accessDomains: [AUTHORIZATIONS.SystemAccess.SystemConfig, AUTHORIZATIONS.SystemAccess.MaintainCostSimulationRules],
  },
  {
    path: "system-settings/system-configuration/legislations/tna-config/:id",
    name: "TnA Legislation Config",
    element: <TnALegislationConfig />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/payment-types",
    name: SystemConfigurationModulesNames.PaymentTypes,
    element: <PaymentTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/payroll-entry-statuses",
    name: SystemConfigurationModulesNames.PayrollEntryStatuses,
    element: <PayrollEntryStatuses />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/payroll-entry-types",
    name: SystemConfigurationModulesNames.PayrollEntryTypes,
    element: <PayrollEntryTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/transaction-statuses",
    name: SystemConfigurationModulesNames.TransactionStatuses,
    element: <TransactionStatuses />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/payroll-entry-statuses",
    name: SystemConfigurationModulesNames.PayrollEntryStatuses,
    element: <PayrollEntryStatuses />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/transaction-types",
    name: SystemConfigurationModulesNames.TransactionTypes,
    element: <TransactionTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/travel-expense-types",
    name: SystemConfigurationModulesNames.TravelExpenseTypes,
    element: <TravelExpenseTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/location-types",
    name: SystemConfigurationModulesNames.LocationTypes,
    element: <LocationTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/wage-types",
    name: SystemConfigurationModulesNames.WageTypes,
    element: <WageTypes />,
    accessDomains: [AUTHORIZATIONS.SystemAccess.SystemConfig, AUTHORIZATIONS.SystemAccess.MaintainWageTypes],
  },
  {
    path: "system-settings/system-configuration/gtn-source-types",
    name: SystemConfigurationModulesNames.GTNSourceTypes,
    element: <GTNSourceTypes />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/widgets",
    name: SystemConfigurationModulesNames.Widgets,
    element: <WidgetsConfig />,
    accessDomains: AUTHORIZATIONS.SystemAccess.SystemConfig,
  },
  {
    path: "system-settings/system-configuration/employee-cost-section-types",
    name: SystemConfigurationModulesNames.EmployeeCostSectionTypes,
    element: <EmployeeCostSectionTypeTable />,
    accessDomains: [AUTHORIZATIONS.SystemAccess.SystemConfig, AUTHORIZATIONS.SystemAccess.MaintainCostSimulationRules],
  },
  {
    path: "system-settings/system-configuration/alert-line-urls",
    name: "Alert line",
    element: <AlertLineURLs />,
  },
  {
    path: "system-settings/system-configuration/alert-line-suggested-notes",
    name: "Alert line suggested notes",
    element: <AlertLineSugestedNotesTable />,
  },
  {
    path: "system-settings/system-configuration/alert-line-claim-types",
    name: "Violation classification",
    element: <ViolationClassification />,
  },
  {
    path: "system-settings/system-configuration/alert-line-report-status",
    name: "Alert line report status",
    element: <AlertLineReportStatus />,
  },
  {
    path: "system-settings/system-configuration/legislation-employee-cost-configuration-type",
    name: "Legislation employee cost configuration type",
    element: <LegislationEmployeeCostConfigurationTypeTable />,
  },
  {
    path: "system-settings/system-configuration/travel-expense-suggested-notes",
    name: "Travel expense suggested notes",
    element: <TravelExpenseSuggestedNotes />,
  },
  {
    path: "system-settings/system-configuration/mail-inboxes",
    name: "Mail Inbox",
    element: <MailInboxTable />,
  },
  {
    path: "system-settings/system-configuration/employee-survey-item-types",
    name: "Employee survey item types",
    element: <EmployeeSurveyItemTypes />,
  },
  {
    path: "system-settings/system-configuration/employee-survey-explanation-suggestions",
    name: "Employee survey explanation suggestions",
    element: <EmployeeSurveyExplanationSuggestions />,
  },

  // Company account settings
  {
    path: "company-account-profile",
    name: "Company Account Profile",
    element: <CompanyAccountProfile />,
    accessDomains: AUTHORIZATIONS.CompanyAccountsAccess.CompanyAccountConfig,
  },
  {
    path: "company-account-configuration",
    name: "Company Account Configuration",
    element: <CompanyAccountConfiguration />,
    accessDomains: AUTHORIZATIONS.CompanyAccountsAccess.CompanyAccountConfig,
  },
  {
    path: "legal-entities",
    name: "Company Legal Entities",
    element: <CompanyLegalEntities />,
    accessDomains: [
      AUTHORIZATIONS.CompanyAccountsAccess.LegalEntityAdminAccess, // prod
      AUTHORIZATIONS.CompanyAccountsAccess.CompanyAccountConfig, // prod
      AUTHORIZATIONS.LegalEntityAccess.LegalEntityConfig,
    ],
    links: [ConfigureCompanyAccountLinks.LegalEntities, ConfigureCompanyAccountLinks.VisibleEeDocuments],
  },
  {
    path: "legal-entities/legal-entity-data/:id",
    name: "Legal entity data",
    element: <LegalEntityDataPage />,
    accessDomains: [
      AUTHORIZATIONS.CompanyAccountsAccess.LegalEntityAdminAccess,
      AUTHORIZATIONS.CompanyAccountsAccess.CompanyAccountConfig,
      AUTHORIZATIONS.LegalEntityAccess.LegalEntityConfig,
    ],
  },
  {
    path: "consolidation-groups",
    name: "Consolidation groups",
    element: <ConsolidationGroupsTable />,
    accessDomains: [],
    links: [ConfigureCompanyAccountLinks.ConsolidationGroups],
  },
  {
    path: "company-accounts-data/:id",
    name: "Company account data",
    element: <CompanyAccountDataPage />,
    accessDomains: [
      AUTHORIZATIONS.SystemAccess.SystemConfig,
      AUTHORIZATIONS.SystemAccess.ServiceProvidersConfig,
      AUTHORIZATIONS.SystemAccess.CompanyAccountsConfig,
      AUTHORIZATIONS.CompanyAccountsAccess.ManageUserAdminAccessToCompanyAccounts,
    ],
  },
  {
    path: "accounting-master-data",
    name: "Accounting Master Data",
    element: <AccountingMasterData />,
    accessDomains: [
      AUTHORIZATIONS.CompanyAccountsAccess.LegalEntityAdminAccess, // dev only
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting, // prod
    ],
    links: [ProcessAccountingLinks.AccountingMasterData],
  },
  {
    path: "client-profile/:id",
    name: "Client profile page",
    element: <ClientProfilePage />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
      AUTHORIZATIONS.CompanyAccountsAccess.LegalEntityAdminAccess,
    ],
  },
  {
    path: "vendor-profile/:id",
    name: "Vendor profile page",
    element: <VendorProfilePage />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
      AUTHORIZATIONS.CompanyAccountsAccess.LegalEntityAdminAccess,
    ],
  },
  {
    path: "legal-entities/tna-config/:id",
    name: "Company legal entities TnAConfig",
    element: <TnALegalEntityConfig />,
    accessDomains: [
      AUTHORIZATIONS.CompanyAccountsAccess.LegalEntityAdminAccess,
      AUTHORIZATIONS.LegalEntityAccess.LegalEntityConfig,
    ],
  },
  {
    path: "employees",
    name: "Employeess",
    element: <EmployeesView />,
    accessDomains: [
      AUTHORIZATIONS.EmployeesAccess.CreateEmployees, // prod: Process employment & payroll
      AUTHORIZATIONS.EmployeesAccess.ViewNonSalaryAndCompensationData, // dev only
      AUTHORIZATIONS.EmployeesAccess.ConfigureEmployeeGroupParameters, // dev only
      AUTHORIZATIONS.LegalEntityAccess.ProcessPayroll, // prod: Process employment & payroll
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting, // prod: Process employment & payroll
    ],
    links: [ProcessEmploymentAndPayrollLinks.EmployeeList],
  },
  {
    path: "employee-report",
    name: "Employee Report",
    element: <EmployeeReport />,
    accessDomains: [AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting],
    links: [ProcessEmploymentAndPayrollLinks.EmployeeReport, ProcessAccountingLinks.EmployeeReport],
  },
  {
    path: "accounting-inputs",
    name: "Accounting Inputs",
    element: <AccountingInputs />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting, // prod: ProcessAccounting
      AUTHORIZATIONS.LegalEntityAccess.UploadDocuments, // prod: Send Us
    ],
    links: [SendUsLinks.AccountingInput, ProcessAccountingLinks.PrepareAccInput],
  },
  {
    path: "payroll-inputs",
    name: "Payroll Inputs",
    element: <PayrollInputs />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.ProcessPayroll, // prod: ProcessEmploymentAndPayroll
      AUTHORIZATIONS.LegalEntityAccess.UploadDocuments, // prod: Send Us
    ],
    links: [SendUsLinks.PayrollInputs, ProcessEmploymentAndPayrollLinks.PayrollInputs],
  },
  {
    path: "provide-payroll-inputs",
    name: "Provide payroll inputs",
    element: <ProvidePayrollInput />,
    accessDomains: [AUTHORIZATIONS.EmployeesAccess.ProvidePayrollInput],
    links: [PayrollOutputLinks.ProvidePayrollInput],
  },
  {
    path: "payroll-runs",
    name: "Payroll runs",
    element: <PayrollRuns />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.ProcessPayroll, //  prod
    links: [PayrollOutputLinks.PayrollCalendar, ProcessEmploymentAndPayrollLinks.ManagePayrollRuns],
  },
  {
    path: "employee-groups",
    name: "Employee groups",
    element: <EmployeeGroups />,
    accessDomains: [
      AUTHORIZATIONS.CompanyAccountsAccess.CompanyAccountConfig, // prod
      AUTHORIZATIONS.CompanyAccountsAccess.EmployeeGroupConfig, // prod
    ],
    links: [ConfigureCompanyAccountLinks.EmployeeGroups],
  },
  // {
  //   path: "employees/tna-config/:id",
  //   name: "Employees TnAConfig",
  //   element: <TnAEmployeeConfig />,
  //   accessDomains: AUTHORIZATIONS.EmployeesAccess.ConfigureEmployeeGroupParameters,
  // },
  {
    path: "employees/employee-data/:id",
    name: "Employees data",
    element: <EmployeeDataPage />,
    accessDomains: [
      AUTHORIZATIONS.EmployeesAccess.ConfigureEmployeeGroupParameters,
      AUTHORIZATIONS.EmployeesAccess.ViewNonSalaryAndCompensationData,
      AUTHORIZATIONS.LegalEntityAccess.ProcessPayroll,
      AUTHORIZATIONS.EmployeesAccess.ChangeEmploymentData,
    ],
  },
  {
    path: "employee-groups/tna-config",
    name: "Employee groups TnAConfig",
    element: <TnAEmployeeGroupConfig />,
    accessDomains: AUTHORIZATIONS.EmployeesAccess.ConfigureEmployeeGroupParameters,
  },
  {
    path: "employee-groups/tna-config/:id",
    name: "Employee groups TnAConfig",
    element: <TnAEmployeeGroupConfig />,
    accessDomains: AUTHORIZATIONS.EmployeesAccess.ConfigureEmployeeGroupParameters,
  },

  {
    path: "recruiting",
    name: "Recruiting",
    element: <Recruiting />,
    accessDomains: [
      AUTHORIZATIONS.RecruitingAccess.CanAddHiringClients,
      AUTHORIZATIONS.RecruitingAccess.CanOpenPositionsAndAddCreateCandidates,
    ],
    links: [RecruitingLinks.HiringClients, RecruitingLinks.Positions, RecruitingLinks.Candidates],
  },

  {
    path: "mutations",
    name: "Employees Mutations",
    element: <EmployeesMutations />,
    accessDomains: AUTHORIZATIONS.EmployeesAccess.ChangeEmploymentData, // dev only
    links: [ProcessEmploymentAndPayrollLinks.Mutations],
  },
  // Company account - functionality
  {
    path: "transactions-forecasts",
    name: "Transactions and Forecasts",
    element: <TransactionsForecasts />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting, // prod
    links: [ProcessAccountingLinks.TransactionForecast],
  },
  {
    path: "assets",
    name: "Assets Page",
    element: <LegalEntityAssets />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
  },
  {
    path: "loans",
    name: "Loans Page",
    element: <LegalEntityLoans />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
  },
  {
    path: "client-invoices",
    name: "Client Invoices Page",
    element: <ClientVendorInvoicesWrapper view={"client"} />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
  },
  {
    path: "vendor-invoices",
    name: "Vendor Invoices Page",
    element: <ClientVendorInvoicesWrapper view={"vendor"} />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
  },
  {
    path: "vendor-invoices",
    name: "Vendor Invoices Page",
    element: <TransactionsForecasts />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
  },
  {
    path: "bank-and-cash",
    name: "Bank and Cash",
    element: <BankAndCashOverview />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
    links: [ProcessAccountingLinks.BankAndCash],
  },
  {
    path: "all-clarifications",
    name: "Clarifications Page",
    element: <Clarifications />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.UploadDocuments, // dev only
    links: [QuestionsAndRequestsLinks.AllClarifications],
  },
  {
    path: "all-documents",
    name: "All Documents",
    element: <Documents />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.UploadDocuments, // dev only
    links: [ProccessDocumentsLinks.AllDocuments],
  },
  {
    path: "incoming-documents",
    name: "Incoming Documents",
    element: <IncomingDocumentsPage />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.UploadDocuments, // dev only
      AUTHORIZATIONS.CompanyAccountsAccess.CanProcessDocumentNotLinkedToLe, // prod
    ],
    links: [ProccessDocumentsLinks.IncomingDocuments],
  },
  {
    path: "my-team-documents",
    name: "My Team Documents",
    element: <Documents />, // TODO use proper page
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.DownloadDocuments,
  },
  {
    path: "my-documents",
    name: "My Documents",
    element: <Documents />, // TODO use proper page
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.DownloadDocuments,
  },
  {
    path: "compliance-documents",
    name: "Compliance documents report",
    element: <ComplianceDocuments />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.RunAccountingReports, // dev only
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting, //    prod
      AUTHORIZATIONS.LegalEntityAccess.ManageLegalEntitySI, // dev only
      AUTHORIZATIONS.LegalEntityAccess.ViewLegalEntitySI,
      AUTHORIZATIONS.LegalEntityAccess.ViewComplianceData,
    ],
    links: [
      ComplianceDocumentsLinks.Compliance,
      ComplianceDocumentsLinks.Assemblies,
      ComplianceDocumentsLinks.Registrations,
      ComplianceDocumentsLinks.Passwords,
    ],
  },
  {
    path: "accounting-documents",
    name: "Accounting documents",
    element: <AccountingOutputDocuments />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.ViewAccountingOutput, // dev only
    links: [AccountingOutputLinks.AccountingDocuments],
  },
  {
    path: "accounting-calendar",
    name: "Accounting calendar",
    element: <AccountingCalendar />,
    accessDomains: AUTHORIZATIONS.LegalEntityAccess.ViewAccountingOutput,
    links: [AccountingOutputLinks.AccountingCalendar],
  },
  {
    path: "payroll-documents",
    name: "Payroll documents",
    element: <PayrollOutputDocuments />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.ViewPayrollOutput, // prod
      AUTHORIZATIONS.LegalEntityAccess.ProcessPayroll, // prod
    ],
    links: [PayrollOutputLinks.PayrollDocument],
  },
  {
    path: "payroll-output-report",
    name: "Payroll output report",
    element: <MyTeamPayrollOutputReport />,
    accessDomains: [AUTHORIZATIONS.EmployeesAccess.ViewSalaryAndCompensationData],
    links: [MyTeamPayrollOutput.MyTeamPayrollOutputReport],
  },

  {
    path: "invoice-tracking",
    name: "Invoice tracking report",
    element: (
      <InvoiceTrackingReport
        allowAuthorizations={[
          AUTHORIZATIONS.LegalEntityAccess.RunAccountingReports,
          AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
        ]}
      />
    ),
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.RunAccountingReports, // dev only
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting, // prod
    ],
    links: [ProcessAccountingLinks.InvoiceTracking],
  },
  {
    path: "my-data",
    name: "My data",
    element: <MyData />,
    links: [MyDataLinks.Data],
  },
  {
    path: "my-personal-documents",
    name: "My documents",
    element: <MyDocuments />,
    links: [MyDocumentsLinks.Documents],
  },
  {
    path: "my-leaves",
    name: "My leaves",
    element: <MyLeavesTable />,
  },
  {
    path: "tna-calendars",
    name: "TnA Calendars",
    element: <TnACalendarsTable />,
    accessDomains: [AUTHORIZATIONS.SystemAccess.CalendarsConfig],
    links: [SystemConfigurationLinks.TnACalendars],
  },
  {
    path: "document-templates",
    name: "Document Templates",
    element: <DocumentTemplatesTable />,
    accessDomains: [
      AUTHORIZATIONS.CompanyAccountsAccess.LegalEntityAdminAccess,
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
      AUTHORIZATIONS.LegalEntityAccess.ProcessPayroll,
      AUTHORIZATIONS.SystemAccess.CompanyAccountsConfig,
    ],
    links: [DocumentTemplatesLinks.AddTemplate],
  },
  // {
  //   path: "employee-data-and-documents/:id",
  //   name: "Employee's data and documents",
  //   element: <EmployeeDataAndDocuments />,
  // },
  {
    path: "employee-data/:id",
    name: "Employee's data",
    element: <EmployeeData />,
  },
  {
    path: "employee-documents/:id",
    name: "Employee's documents",
    element: <EmployeeDocuments />,
  },
  {
    path: "my-t-and-a",
    name: "My T&A",
    element: <MyTAndA />,
  },
  {
    path: "my-ee-t-and-a/:id",
    name: "My T&A",
    element: <MyEeTAndA />,
  },
  {
    path: "company-documents",
    name: "Company documents",
    element: <CompanyAccountDocuments />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
      AUTHORIZATIONS.LegalEntityAccess.RunAccountingReports,
      AUTHORIZATIONS.LegalEntityAccess.ViewComplianceData,
      AUTHORIZATIONS.LegalEntityAccess.ProcessIncomingDocuments,
    ],
    links: [ComplianceDocumentsLinks.CompanyAccountDocuments],
  },
  {
    path: "company-account-overview",
    name: "Company account overview",
    element: <CompanyAccountOverviewWrapper />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.LegalEntityConfig,
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
      AUTHORIZATIONS.LegalEntityAccess.RunAccountingReports,
      AUTHORIZATIONS.LegalEntityAccess.ViewComplianceData,
      AUTHORIZATIONS.LegalEntityAccess.ProcessIncomingDocuments,
    ],
    links: [ComplianceDocumentsLinks.CompanyAccountOverview],
  },
  {
    path: "legal-entity-administrative-process",
    name: "Legal entity administrative process",
    element: <LegalEntityAdministrativeProcessWrapper />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.LegalEntityConfig,
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
      AUTHORIZATIONS.LegalEntityAccess.RunAccountingReports,
      AUTHORIZATIONS.LegalEntityAccess.ViewComplianceData,
      AUTHORIZATIONS.LegalEntityAccess.ProcessIncomingDocuments,
    ],
    links: [ComplianceDocumentsLinks.LegalEntityAdministrativeProcess],
  },
  {
    path: "archive-download",
    name: "Archive download",
    element: <ArchiveDownloadWrapper />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.ViewComplianceData,
      AUTHORIZATIONS.LegalEntityAccess.AuthorizeArchiveDownload,
    ],
    links: [ComplianceDocumentsLinks.ArchiveDownload],
  },
  {
    path: "my-team-presence-and-leaves",
    name: "My T&A Dashboard",
    element: <TnAOverviews />,
    accessDomains: [
      AUTHORIZATIONS.EmployeesAccess.ApproveTimeAndLeaves,
      AUTHORIZATIONS.EmployeesAccess.ViewNonSalaryAndCompensationData,
    ],
    links: [MyTeamPresenceAndLeavesLinks.Dashboard],
  },
  {
    path: "my-client-team-presence-and-leaves",
    name: "My client T&A Dashboard",
    element: <MyClientTeamPresenceAndLeaves />,
    accessDomains: [AUTHORIZATIONS.UserIsClient],
    links: [MyClientTeamPresenceAndLeavesLinks.Dashboard],
  },
  {
    path: "my-client-team-pending-approvals",
    name: "My client team pending approvals",
    element: <PendingClientApprovals />,
    accessDomains: [AUTHORIZATIONS.UserIsClient],
    links: [MyClientTeamPendingApprovalsLinks.Absences, MyClientTeamPendingApprovalsLinks.ExpenseClaims],
  },
  {
    path: "my-team-pending-approvals",
    name: "My team pending approvals",
    element: <ProjectAssignmentsPendingApprovals />,
    accessDomains: [
      AUTHORIZATIONS.EmployeesAccess.ApproveTimeAndLeaves,
      AUTHORIZATIONS.EmployeesAccess.ApproveExpenses,
    ],
    links: [MyTeamPendingApprovalsLinks.Absences, MyTeamPendingApprovalsLinks.ExpenseClaims],
  },
  {
    path: "my-team-project-assignments",
    name: "My Team project assignments",
    element: <MyTeamProjectAssignments />,
    accessDomains: [
      AUTHORIZATIONS.UserIsClient,
      AUTHORIZATIONS.EmployeesAccess.ApproveTimeAndLeaves,
      AUTHORIZATIONS.EmployeesAccess.ApproveExpenses,
      AUTHORIZATIONS.EmployeesAccess.ViewNonSalaryAndCompensationData,
    ],
    links: [
      MyTeamProjectAssignmentLinks.Overview,
      MyTeamProjectAssignmentLinks.AssignedEmployees,
      // MyTeamProjectAssignmentLinks.PendingApprovals,
    ],
  },
  {
    path: "my-team-payroll-runs",
    name: "My team payroll runs",
    element: <PayrollRuns userIsClient />,
    accessDomains: [AUTHORIZATIONS.EmployeesAccess.ViewSalaryAndCompensationData],
    links: [MyTeamPayrollOutput.MyTeamPayrollCalendar],
  },
  {
    path: "my-team-employees-documents",
    name: "My team documents",
    element: <MyTeamDocuments />,
    accessDomains: [AUTHORIZATIONS.EmployeesAccess.ViewSalaryAndCompensationData],
    links: [MyTeamDocumentsLinks.MyTeamDocuments],
  },
  {
    path: "user-access-rights",
    name: "User access rights",
    element: <UserAccessRightsView />,
    accessDomains: [
      AUTHORIZATIONS.SystemAccess.ManageUserAdminAccess,
      AUTHORIZATIONS.SystemAccess.SystemConfig,
      AUTHORIZATIONS.SystemAccess.ServiceProvidersConfig,
      AUTHORIZATIONS.SystemAccess.CompanyAccountsConfig,
      AUTHORIZATIONS.CompanyAccountsAccess.ManageUserAdminAccessToCompanyAccounts,
      AUTHORIZATIONS.CompanyAccountsAccess.CompanyAccountConfig,
      AUTHORIZATIONS.LegalEntityAccess.ManageUserAdminAccess_ToLegalEntities,
      AUTHORIZATIONS.CompanyAccountsAccess.LegalEntityAdminAccess,
      AUTHORIZATIONS.LegalEntityAccess.LegalEntityConfig,
      AUTHORIZATIONS.CompanyAccountsAccess.EmployeeGroupConfig,
      AUTHORIZATIONS.EmployeesAccess.GiveUsersAccessToThisEmployeeGroup,
      AUTHORIZATIONS.RecruitingAccess.CanProvideUserAccess,
    ],
    links: [UserManagementLinks.UserAccessRights],
  },
  {
    path: "user-activity",
    name: "User activity",
    element: <UserActivity />,
    accessDomains: [
      AUTHORIZATIONS.SystemAccess.ManageUserAdminAccess, // prod
    ],
    links: [UserManagementLinks.UserActivity],
  },
  {
    path: "access-to-company-accounts",
    name: "Access to company accounts",
    element: <AccessToCompanyAccounts />,
    // accessDomains: [],                     prod -
    links: [UserManagementLinks.AccessToCompanyAccounts],
  },
  {
    path: "access-to-legal-entity",
    name: "Access to legal entity",
    element: <AccessToLegalEntities />,
    accessDomains: [
      AUTHORIZATIONS.SystemAccess.ManageUserAdminAccess, // prod
    ],
    links: [UserManagementLinks.AccessToLegalEntities],
  },
  {
    path: "view-policies",
    name: "View Policies",
    element: <ViewPolicies />,
    links: [PoliciesLinks.ViewReviewedPolicies],
  },
  {
    path: "manage-policies",
    name: "Manage Policies",
    element: <ManagePolicies />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.ViewComplianceData,
      AUTHORIZATIONS.LegalEntityAccess.ManagePolicies,
      AUTHORIZATIONS.CompanyAccountsAccess.ManagePolicies,
      AUTHORIZATIONS.EmployeesAccess.ViewNonSalaryAndCompensationData,
    ],
    links: [PoliciesManagmentLinks.ManagePolicies],
  },
  {
    path: "pnl-report",
    name: "PnL Report",
    element: <PnLReports />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting, // prod
    ],
    links: [ProcessAccountingLinks.PnlReport],
  },
  {
    path: "manage-travel-and-expenses",
    name: "Manage Travel And Expenses",
    element: <ManageTravelAndExpenses />,
    accessDomains: [
      AUTHORIZATIONS.EmployeesAccess.ApproveExpenses,
      AUTHORIZATIONS.EmployeesAccess.PayExpenses,
      AUTHORIZATIONS.EmployeesAccess.ViewNonSalaryAndCompensationData,
      AUTHORIZATIONS.EmployeesAccess.AuditTravelAndExpenses,
    ],
    links: [MyTeamTravelAndExpensesLinks.ManageTravelAndExpenses],
  },
  {
    path: "my-travel-and-expenses",
    name: "My Travel And Expenses",
    element: <MyTravelAndExpenses />,
    links: [MyTravelAndExpensesLinks.TravelAndExpensesInProgress],
  },
  {
    path: "user-profile",
    name: "User Profile",
    element: <UserProfile />,
  },
  {
    path: "split-employee-document",
    name: "Split employee document",
    element: <SplitEmployeeDocumentTable />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.LegalEntityConfig,
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
      AUTHORIZATIONS.LegalEntityAccess.RunAccountingReports,
      AUTHORIZATIONS.LegalEntityAccess.ViewComplianceData,
      AUTHORIZATIONS.LegalEntityAccess.ProcessIncomingDocuments,
      AUTHORIZATIONS.LegalEntityAccess.ProcessPayroll,
    ],
    links: [ProcessEmploymentAndPayrollLinks.SplitEmployeeDocument],
  },
  {
    path: "employee-cost",
    name: "Employee cost",
    element: <EmployeeCostReportPage />,
    links: [ProcessEmploymentAndPayrollLinks.ProformaEmployeeCostReport],
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
      AUTHORIZATIONS.LegalEntityAccess.ProcessPayroll,
      AUTHORIZATIONS.LegalEntityAccess.RunAccountingReports,
    ],
  },
  {
    path: "manage-alert-line-reports",
    name: "Manage alert line reports",
    element: <ManageAlertLine />,
  },
  {
    path: "users",
    name: "users",
    element: <UserLoginStats />,
    accessDomains: [
      AUTHORIZATIONS.LegalEntityAccess.ManageUserAdminAccess_ToLegalEntities,
      AUTHORIZATIONS.LegalEntityAccess.UploadDocuments,
      AUTHORIZATIONS.LegalEntityAccess.DownloadDocuments,
      AUTHORIZATIONS.LegalEntityAccess.ProcessIncomingDocuments,
      AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
      AUTHORIZATIONS.LegalEntityAccess.RunAccountingReports,
      AUTHORIZATIONS.LegalEntityAccess.ViewAccountingOutput,
      AUTHORIZATIONS.LegalEntityAccess.ViewPayrollOutput,
      AUTHORIZATIONS.LegalEntityAccess.ProcessPayroll,
      AUTHORIZATIONS.LegalEntityAccess.ViewComplianceData,
      AUTHORIZATIONS.LegalEntityAccess.ViewActivityData,
      AUTHORIZATIONS.LegalEntityAccess.ManagePolicies,
      AUTHORIZATIONS.EmployeesAccess.ConfigureEmployeeGroupParameters,
      AUTHORIZATIONS.EmployeesAccess.CreateEmployees,
      AUTHORIZATIONS.EmployeesAccess.ViewNonSalaryAndCompensationData,
      AUTHORIZATIONS.EmployeesAccess.ApproveTimeAndLeaves,
      AUTHORIZATIONS.EmployeesAccess.ApproveExpenses,
      AUTHORIZATIONS.EmployeesAccess.PayExpenses,
      AUTHORIZATIONS.EmployeesAccess.ChangeEmploymentData,
      AUTHORIZATIONS.EmployeesAccess.ViewSalaryAndCompensationData,
      AUTHORIZATIONS.EmployeesAccess.CreateAndManageClientMissions,
      AUTHORIZATIONS.EmployeesAccess.EnterClientApprovals,
      AUTHORIZATIONS.EmployeesAccess.GiveEmployeesAccessToTheirOwnEmploymentData,
      AUTHORIZATIONS.EmployeesAccess.GiveUsersAccessToThisEmployeeGroup,
      AUTHORIZATIONS.EmployeesAccess.AuditTravelAndExpenses,
      AUTHORIZATIONS.EmployeesAccess.ApproveNonAuditedExpenses,
      AUTHORIZATIONS.EmployeesAccess.ProvidePayrollInput,
    ],
    links: [SystemAnalyticsLinks.Users],
  },
  {
    path: "employee-group-clients",
    name: "employee-group-clients",
    element: <LegalEntityClientsFilteredByEmployeeGroupsTable />,
    accessDomains: [AUTHORIZATIONS.EmployeesAccess.ViewRelatedComplianceData],
    links: [AccountManagementLinks.Clients],
  },
  {
    path: "my-team-policies",
    name: "my-team-policies",
    element: <MyTeamPolicies />,
    accessDomains: [AUTHORIZATIONS.EmployeesAccess.ViewPolicies],
    links: [MyTeamPoliciesLinks.MyTeamPoliciesLinks],
  },
  {
    path: "manage-mail",
    name: "manage-mail",
    element: <ManageMail />,
  },
  {
    path: "manage-employee-surveys",
    name: "manage-employee-surveys",
    element: <ManageEmployeeSurveyConfigurationPage />,
  },
  {
    path: "my-surveys",
    name: "my-surveys",
    element: <MySurveysPage />,
  },
  {
    path: "manage-provider-site-advertisement-popups",
    name: "manage-provider-site-advertisement-popups",
    element: <ManageProviderSiteAdvertisementPopupsPage />,
  },
  {
    path: "clocking-location-codes",
    name: "clocking-location-codes",
    element: <TnALocationCodesPage />,
  },
  {
    path: "generate-clocking-location-qr-code",
    name: "generate-clocking-location-qr-code",
    element: <TnAClockingLocationQRCodePage />,
    links: [ClockingLocationQRCodeLinks.GenerateCode],
    accessDomains: [AUTHORIZATIONS.UserIsAllowedToGenerateTnALocationQR],
  },
];
